import { ClipboardCheck, FileText, FlaskConical, HardHat, LogOut, Menu, PanelLeftClose, PanelLeftOpen, Repeat2, Settings2, UsersRound, X } from "lucide-react";
import { useState } from "react";
import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useSession } from "../state/SessionContext";

const links = [
  { to: "/muestreos", label: "Muestreos y pruebas", icon: FlaskConical },
  { to: "/ejecucion-obra", label: "Ejecución de obra", icon: HardHat },
  { to: "/certificados", label: "Certificados e informes", icon: ClipboardCheck },
  { to: "/comunicaciones", label: "Comunicaciones", icon: FileText },
  { to: "/configuracion-calidad", label: "Actividades y materiales", icon: Settings2 },
  { to: "/administracion-contrato", label: "Administración del contrato", icon: UsersRound },
];

export function ProtectedRoute() {
  const { session, loading } = useSession();
  const location = useLocation();
  if (loading) return <div className="splash"><div className="brand-mark">K</div><p>Preparando KALITE…</p></div>;
  if (!session) return <Navigate to="/acceso" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

export function ContextRoute() {
  const { context } = useSession();
  if (!context) return <Navigate to="/contexto" replace />;
  return <AppLayout />;
}

function AppLayout() {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const { profile, context, clearContext } = useSession();
  return <div className={collapsed ? "app-shell sidebar-collapsed" : "app-shell"}>
    {open && <button className="nav-scrim" aria-label="Cerrar menú" onClick={() => setOpen(false)} />}
    <aside className={open ? "sidebar open" : "sidebar"}>
      <div className="sidebar-brand"><span className="brand-mark small">K</span><div><strong>KALITE</strong><small>Gestión de calidad</small></div><button className="icon-button mobile-only" onClick={() => setOpen(false)}><X /></button></div>
      <button className="sidebar-toggle" onClick={() => setCollapsed((value) => !value)} aria-label={collapsed ? "Mostrar menú lateral" : "Ocultar menú lateral"} title={collapsed ? "Mostrar menú lateral" : "Ocultar menú lateral"}>{collapsed ? <PanelLeftOpen size={19} /> : <PanelLeftClose size={19} />}<span>{collapsed ? "Mostrar menú" : "Ocultar menú"}</span></button>
      <nav>{links.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} onClick={() => setOpen(false)} title={collapsed ? label : undefined}><Icon size={19} /><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-bottom">
        <button className="context-switch" title={collapsed ? "Cambiar contexto" : undefined} onClick={() => clearContext()}><Repeat2 size={17} /><span><small>Cambiar contexto</small><strong>{context?.contrato_numero}</strong></span></button>
        <button className="logout" title={collapsed ? "Cerrar sesión" : undefined} onClick={() => void supabase.auth.signOut()}><LogOut size={17} /><span>Cerrar sesión</span></button>
      </div>
    </aside>
    <main className="main">
      <header className="topbar"><button className="icon-button mobile-only" onClick={() => setOpen(true)}><Menu /></button><div className="context-label"><strong>{context?.proyecto_nombre}</strong><span>{context?.contrato_numero} · {context?.area_nombre || context?.rol}</span></div><div className="user-chip">{profile?.nombre_completo || profile?.nombre || "Usuario"}</div></header>
      <div className="page"><Outlet /></div>
    </main>
  </div>;
}
